<app-mu-modal-dialog-layout
  id="mu-alert-modal-dialog"
  [title]="title"
  [icon]="icon"
  [showFlag]="showFlag"
  [flagList]="flagList"
  [actionFlag]="actionFlag"
  [loaderFlag]="loaderFlag"
  [buttonMainActionLabel]="buttonMainActionLabel"
  [buttonCancelLabel]="buttonCancelLabel"
  [buttonCancelLink]="buttonCancelLink"
  [queryParametersCancelLink]="queryParametersCancelLink"
>
  <p modalDialogContent class="p-col-12 mu-modal-text mu-without-padding" [innerHTML]="message"></p>
  <ng-content></ng-content>
</app-mu-modal-dialog-layout>
